import { createStore } from 'vuex';
import auth from './modules/auth';
import booking from './modules/booking';
import clubs from './modules/clubs';
import orders from './modules/orders';

export default createStore({
  modules: {
    auth,
    booking,
    clubs,
    orders,
  },
});
